import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { SurveyScore } from '@ps/survey-utils';

import { SurveyScoreDto } from './score.dto';
import { SurveyScoreMapper } from './mappers/survey-score.mapper';

export interface ComputeScoreParams {
  cpi: number;
  ir: number;
  loi: number;
}

@Injectable({ providedIn: 'root' })
export class SurveyScoreApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = `${this._env.pureSpectrum.url}`;
  private readonly _mapper = new SurveyScoreMapper();

  public computeScore(
    surveyId: number,
    params: ComputeScoreParams,
  ): Observable<SurveyScore> {
    const _params = new HttpParams({ fromObject: { ...params } });

    return this._http
      .get<SurveyScoreDto>(`${this._baseUrl}/surveys/${surveyId}/score`, {
        params: _params,
      })
      .pipe(map((dto) => this._mapper.fromDto(dto)));
  }
}
